<app-main-layout>
  <div class="bg-gray-50 min-h-screen">
  <div class="py-6 px-4 sm:px-6 max-w-[960px] mx-auto">

    <!-- Header -->
    <div class="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-6">
      <div class="flex items-center gap-4 min-w-0">
        <button type="button" (click)="backToList()"
          class="h-10 w-10 flex-shrink-0 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center text-gray-500 hover:text-gray-900 hover:border-amber-300 transition-colors"
          matTooltip="Back to staff" aria-label="Back to staff">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <span class="relative h-12 w-12 rounded-full flex items-center justify-center font-bold flex-shrink-0"
          [ngClass]="member?.roles?.includes('S-ADMIN') ? 'bg-neutral-900 text-amber-400' : 'bg-gradient-to-br from-amber-300 to-amber-500 text-neutral-900'">
          @if (member) { {{ initials(member) }} } @else { <mat-icon>person_add</mat-icon> }
          @if (member) { <span class="absolute -bottom-0.5 -right-0.5 h-3.5 w-3.5 rounded-full ring-2 ring-gray-50" [ngClass]="member.isActive ? 'bg-emerald-500' : 'bg-gray-400'"></span> }
        </span>
        <div class="min-w-0">
          <div class="flex items-center gap-1.5 text-xs text-gray-400">
            <button type="button" class="hover:text-gray-700" (click)="backToList()">Staff</button>
            <mat-icon class="!text-[14px] !h-3.5 !w-3.5">chevron_right</mat-icon>
            <span>{{ isEdit ? 'Edit' : 'New' }}</span>
          </div>
          <h1 class="text-2xl font-bold text-gray-900 tracking-tight truncate max-w-[70vw] lg:max-w-[460px]">{{ loading ? 'Loading…' : (name(member) || 'New staff member') }}</h1>
          @if (member) {
            <div class="mt-1 flex flex-wrap items-center gap-1">
              @for (r of member.roles; track r) { <span class="text-[11px] font-semibold px-2 py-0.5 rounded-md" [ngClass]="badge(r)">{{ label(r) }}</span> }
              @if (!member.isActive) { <span class="text-[11px] font-semibold px-2 py-0.5 rounded-md bg-gray-200 text-gray-600">Inactive</span> }
            </div>
          } @else if (!isEdit) {
            <p class="text-xs text-gray-500">Pick every role this person needs, then the pages they should see</p>
          }
        </div>
      </div>
      @if (isEdit && nav.length) {
        <app-record-nav noun="person" listName="Staff" [position]="position" [total]="nav.length"
          [prevName]="name(prev)" [nextName]="name(next)" [disabled]="loading" (prev)="goTo(prev)" (next)="goTo(next)"></app-record-nav>
      }
    </div>

    @if (loading) {
      <div class="rounded-2xl bg-white border border-gray-100 py-24 flex flex-col items-center justify-center text-sm text-gray-500">
        <mat-spinner diameter="40"></mat-spinner><span class="mt-3">Loading&hellip;</span>
      </div>
    } @else if (notFound) {
      <div class="rounded-3xl border-2 border-dashed border-gray-200 bg-white py-16 text-center">
        <span class="mx-auto h-14 w-14 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center"><mat-icon class="!text-[28px] !h-7 !w-7">person_off</mat-icon></span>
        <p class="mt-3 text-sm font-semibold text-gray-700">That person isn't on the staff list</p>
        <button type="button" class="mt-4 text-xs font-semibold text-amber-700 hover:underline" (click)="backToList(true)">Back to staff</button>
      </div>
    } @else if (formData) {
      <app-staff-dialog [pageData]="formData" (done)="onDone($event)"></app-staff-dialog>
    }
  </div>
  </div>
</app-main-layout>
